import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    activity: {},
    // 线索来源
    source: null
  },
  getters: {
  },
  mutations: {
    setActivity: (state, activity) => {
      state.activity = activity
    },
    setSource: (state, source) => {
      state.source = source
    }
  },
  actions: {
  },
  modules: {
  }
})
